import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Config } from '../../config/index';
import { logout } from '../../features/auth/authSlice';

const SetNewPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!password || !confirmPassword) {
            return toast.error("Please enter and confirm your new password");
        }
        if (password.length < 6) {
            return toast.error("Password must be at least 6 characters");
        }
        if (password !== confirmPassword) {
            return toast.error("Passwords do not match");
        }
        setIsSubmitting(true);
        try {
            const res = await axios.post(`${Config.API_URL}/users/reset-password-token`, { token, password });
            toast.success(res.data?.message || "Password reset successful");
            // clear any persisted session so /signin doesn't bounce to /home
            await dispatch(logout());
            navigate('/signin');
        } catch (err) {
            toast.error(err?.response?.data?.message || "Reset link is invalid or has expired.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="w-screen h-screen flex items-center justify-center bg-gray-50">
            <div className="bg-white rounded-md shadow-md w-full max-w-md">
                <div className="mt-[1.5rem] mx-9">
                    <h1 className="text-xl font-semibold">Set New Password</h1>
                    <p className="text-xs text-gray-500 mt-1">Enter a new password for your BattScan account.</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mt-[1.5rem] mx-9">
                        <label className="text-start font-semibold text-xs">New Password</label>
                        <input
                            required
                            type="password"
                            minLength={6}
                            className="font-medium py-2 pl-2 text-xs bg-slate-50 w-full rounded-[0.375rem] border-x-0 border-t-0 border-b-2 border-b-[#25C454]"
                            placeholder="Enter new password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="mt-[0.4rem] mx-9">
                        <label className="text-start w-full font-semibold text-xs">Confirm Password</label>
                        <input
                            required
                            type="password"
                            minLength={6}
                            className="font-medium py-2 pl-2 text-xs w-full bg-slate-50 rounded-[0.375rem] border-x-0 border-t-0 border-b-2 border-[#25C454]"
                            placeholder="Re-enter new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    <div className="mx-9 mt-[2.5rem] pb-[2.5rem]">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="py-3 font-semibold w-full rounded-[0.375rem] bg-[#25C454] text-white text-base">
                            {isSubmitting ? 'Loading....' : 'Reset Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SetNewPassword;
